module.exports = __webpack_public_path__ + "static/media/video-screenshot.2a40fe5e.png";